import { useSiteStore } from '~/stores/site.store';
import type { ISitemapRemap } from '~/interfaces/dto/sitemap/response';
import { appleAppIds } from 'assets/data/config';
import { getAbsoluteUrl } from '~/utilities/useAbsoluteUrl';

export default function useGetPage(
  {
    path,
    setSeoMeta,
  }: {
    path?: string;
    setSeoMeta?: boolean;
  } = { setSeoMeta: true },
) {
  const route = useRoute();
  const settings = useSiteStore();
  const { getLocale } = useLocaleUtils();

  const getPath = (path: string = ''): Partial<ISitemapRemap> => {
    if (path === 'undefined') path = '';
    return (
      settings.getSitemapMap.get(`/${path}`) ||
      settings.getSitemapMap.get(`/${path}/`)
    );
  };

  const page = computed<
    Partial<ISitemapRemap> & { head: Record<string, unknown> }
  >(() => {
    const pageValue =
      route.params.contentType !== 'home' || !!path
        ? getPath(path || String(route.params.contentType))
        : getPath();

    const lang = getLocale().includes('en')
      ? `en-${settings.getRegion}`
      : getLocale();
    const head = {
      meta: [
        {
          name: 'Jackpot City',
          content: `app-id=${appleAppIds[settings.getRegionCode]}, app-argument=${document?.location?.host}`,
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: getAbsoluteUrl(route.path),
        },
      ],
      htmlAttrs: {
        lang,
      },
    };

    return { ...(pageValue ?? getPath()), head };
  });

  if (setSeoMeta) {
    const metaParams = page.value?.nuxtSeoParams;
    useHead(page.value?.head);
    useSeoMeta({
      ...(!!metaParams && metaParams),
      ogUrl: getAbsoluteUrl(route.path),
    });
  }

  return page;
}
